import React from 'react';
import { Tooltip } from 'antd';
import { BlockFolderIcon, TetherIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  title: string;
  testCount: number;
  image?: string;
  color?: string;
  url: string;
}

export const SubjectCard = ({ title, testCount, image, url, color }: IProps) => {
  const t = useTranslations();

  return (
    <Link
      href={url}
      className="shadow-gray-sm group relative flex h-36 cursor-pointer items-center justify-center rounded-2xl border border-gray-300 bg-white transition-all duration-300 hover:border-green-500 hover:bg-green-100 hover:shadow-none"
    >
      <Tooltip title={t('test_soni')}>
        <div className="absolute right-3 top-3 flex h-6 items-center justify-center gap-1 rounded-full bg-gray-100 px-2 text-gray-400 transition-all duration-300 group-hover:bg-green-500 group-hover:text-white">
          <TetherIcon />
          <span className="text-xs font-medium">{testCount}</span>
        </div>
      </Tooltip>
      <div className="flex flex-col items-center gap-y-3">
        {image ? (
          <div className="relative h-14 w-14">
            <Image src={image as string} alt="Subject" fill />
          </div>
        ) : (
          <BlockFolderIcon bodyColor={color} />
        )}
        <p className="font-medium text-sm max-w-3/4 text-center line-clamp-2">{title}</p>
      </div>
    </Link>
  );
};
